<div class="allDocument">
  <div>
    <app-case-document-filter (filterByTags)="filterByTag($event)" (searchFilterTextChangeds)="searchFilterTextChanged($event)">
    </app-case-document-filter>
  </div>
  <div>
    <app-case-document-table #caseDocumentsTable [caseId]="caseId" [caseNumber]="caseNumber"></app-case-document-table>
  </div>
</div>
